import { contactUsEntityName } from '../../../../../backend/features/contact-us/shared';
import { requireAnySystemPermission } from '../../../../../backend/features/permissions/shared';
import { ContactUsAdminPage } from './ContactUsAdminPage';
export const contactUsAdminPages = [
    {
        label: 'Contact Us',
        name: contactUsEntityName,
        path: 'contactus',
        groupLabel: 'General',
        component: ContactUsAdminPage,
    },
];
export function getContactUsAdminPage(userState, ...additionalPermissions) {
    if (requireAnySystemPermission(userState, 'manage-all-classifiers', ...additionalPermissions)) {
        return [...contactUsAdminPages];
    }
    else {
        return [];
    }
}
